import { useMemo } from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
function useEmotionStyledComponent(styles, WrappedComponent, props) {
    var theme = useTheme();
    var root = styles(theme, props).root;
    return useMemo(function () {
        return styled(WrappedComponent)(root);
    }, [WrappedComponent]);
}
export default useEmotionStyledComponent;
